import { createApp } from 'vue';
import store from '@/store';
import App from '@/App.vue';
import router from '@/router';
import axios from 'axios';
import app_mixin from "@/mixin";
import lib from '@/lib';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const app = createApp(App);

window['appInstance'] = null;
window['appComponent'] = null;
window['storeInstance'] = null;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
app.use(router);
app.use(store);
lib.addMixin(app_mixin);
app.mount('#app');

window['lib'] = lib;
window['axios'] = axios;

window['appInstance'] = app;
window['storeInstance'] = store;
